import clsx from 'clsx';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Avatar from 'src/components/avatar/avatar';
import { ElementaryHeaderButtons } from 'src/components/buttons/elementary-header-buttons';
import { Screens } from 'src/interfaces/screens.types';
import { Theme } from 'src/interfaces/theme.types';
import AuthService from 'src/services/api/auth.service';
import { useCurrentGradeSelector } from 'src/store/features';
import { getToday } from 'src/utils/date.utils';
import { getTheme } from 'src/utils/theme.utils';

import './elementary-school-header.scss';

export type ElementarySchoolHeaderProps = {
  currentScreen: Screens;
};

export const ElementarySchoolHeader: FC<ElementarySchoolHeaderProps> = ({
  currentScreen,
}) => {
  const { t } = useTranslation();

  const currentGrade = useCurrentGradeSelector();

  const theme = getTheme(currentGrade, false);

  const isHomeScreen = currentScreen === Screens.homeScreen;
  const isTeacher = AuthService.isTeacher();
  const shouldShowTodaySection = theme !== Theme.K1 && !isTeacher;

  return (
    <header className={clsx('elementary-school-header', 'theme-k5')}>
      <Avatar />
      <div className="elementary-school-header__buttons-container bg-dark">
        {isHomeScreen && <ElementaryHeaderButtons theme={theme} />}
      </div>
      {shouldShowTodaySection && (
        <p className="elementary-school-header__date" data-testid="header-date">
          <span>{t('Today is')}</span>
          <span>{getToday()}</span>
        </p>
      )}
    </header>
  );
};
